import classNames from 'classnames';
import styles from 'styles/components/common/elements/MultipleSelectBtns.module.scss';
import { TBtnGroup } from 'types/button';

type TProps = {
  btnGroup: TBtnGroup[];
  btnStates: boolean[];
  btnStyles: React.CSSProperties;
  onChange: (index: number) => void;
};

const MultipleSelectBtns = ({
  btnGroup,
  btnStates,
  btnStyles,
  onChange,
}: TProps) => {
  return (
    <span className={styles.btn_wrapper}>
      {Array.from({ length: btnGroup.length }, (_, index) => (
        <button
          key={index}
          className={classNames(styles.btn, {
            [styles.selected]: btnStates[index],
          })}
          onClick={() => onChange(index)}
          style={btnStyles}
        >
          {btnGroup[index]?.label}
        </button>
      ))}
    </span>
  );
};

export default MultipleSelectBtns;
